import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  container: {
    height: '100%',
    width: '100%',
    boxSizing: 'border-box',
  },
  postContainer: {
    height: '100%',
  },
  asideContainer: {
    [theme.breakpoints.down('md')]: {
      paddingLeft: 0,
    },
    paddingTop: 0,
    paddingLeft: theme.spacing(4),
  },
  fullWidthSidebarContainer: {
    paddingTop: theme.spacing(4),
    paddingLeft: 0,
  },
}));
